const creator = {
  title: '达人管理',
  tabs_label: '达人管理分类',
  tab_mine: '我的达人',
  tab_blacklist: '达人黑名单',
  tab_collab: '合作达人',
  tab_intent: '意向达人',
  mine_subtitle: '从广场收藏、邀约、私信、邮件模块同步达人',
  blacklist_subtitle: '拉黑后邀约 / 私信 / 邮件 一律排除',
  blacklist_hint: '加入后私信、邮件、定向邀约会自动移除；已在列表者不再回显。',
  collab_subtitle: '已合作 / 合作中 · 可查看详情与统计',
  collab_hint: '包含正在合作与已出单。数据来自商家选品库履约与带货概览（限量）。',
  intent_subtitle: '已沟通、有回应，但尚未进入合作',
  intent_hint: '规范：有邮件或私信，且尚未进入合作达人。黑名单不展示。',
  search_placeholder: '搜索达人 / 昵称',
  last_channel: '最新回复渠道',
  channel_dm: '私信',
  channel_email: '邮件',
  reply_counts: '私信 {{dm}} · 邮件 {{email}}',
  batch_outreach: '批量建联',
  batch_invite: '批量邀约',
  find_talent: '找达人',
  add_invite: '加入邀约',
  send_dm: '发私信',
  send_email: '发邮件',
  mine_count: '共 {{count}} 人',
  load_failed: '我的达人加载失败',
  intent_load_failed: '意向达人加载失败',
  collab_load_failed: '合作达人加载失败',
  col_source: '合作来源',
  source_invite_accepted: '邀约接受',
  source_chat: '沟通转合作',
  col_added_products: '已添加商品',
  blacklist_load_failed: '黑名单加载失败',
  blacklist_current: '在黑名单',
  blacklist_history: '移出历史',
  removed_tag: '已移出',
  tag_none: '无标签',
  col_talent: '达人',
  col_tags: '标签',
  gmv30: '近 30 日 GMV',
  followers: '粉丝',
  col_actions: '操作',
  tag_coop: '合作',
  tag_high_conv: '高转化',
  tag_intent: '意向',
  outreach: '建联',
  unfavorite: '取消收藏',
  unfavorite_confirm: '确定取消收藏「{{name}}」吗？',
  unfavorite_success: '已取消收藏 {{name}}',
  unfavorite_failed: '取消收藏失败',
  add_blacklist: '加入黑名单',
  col_added_by: '添加人',
  col_region: '地区',
  col_added_at: '添加时间',
  col_reason: '原因',
  remove: '移出',
  remove_confirm: '确定将「{{name}}」移出黑名单吗？',
  blacklist_removed: '已移出黑名单：{{name}}',
  blacklist_remove_failed: '移出黑名单失败',
  blacklist_missing_remove_id: '缺少达人 ID，无法移出',
  col_status: '状态',
  col_start: '合作开始',
  col_shop: '店铺',
  col_product: '合作商品',
  sales_gmv: '带货 GMV',
  col_orders: '订单',
  sales_detail: '带货详情',
  no_sales_data: '暂无带货数据',
  col_stage: '阶段',
  col_channels: '沟通渠道',
  col_last_interaction: '最近互动',
  col_last_content: '最近内容',
  col_reply: '回复',
  view_email: '看邮件',
  email_thread: '邮件往来：{{name}}',
  convert_collab: '转为合作',
  convert_confirm: '确认将「{{name}}」转为当前店铺的合作达人？',
  converted_collab: '已转为合作：{{name}}',
  convert_failed: '转为合作失败',
  reason_poor: '履约差',
  reason_timeout: '超时未发',
  reason_no_update: '多次催更无响应',
  reason_fraud: '欺诈风险',
  reason_policy: '违规 / 投诉',
  reason_other: '其他',
  remark: '补充说明',
  select_talent_required: '请选择达人',
  blacklist_missing_id: '缺少达人 ID，无法拉黑',
  blacklist_failed: '加入黑名单失败',
  blacklist_added: '已加入黑名单：{{talent}}（{{reason}}）',
  select_talent: '选择达人',
  reason: '原因',
  join: '加入',
  col_item: '商品',
  col_coop_time: '合作时间',
  col_showcase: '橱窗',
  col_videos: '视频',
  col_live: '直播',
  commission: '佣金',
  video_live: '视频 / 直播',
  ctr: '点击率',
  collab_heading: '{{name}} · 合作详情',
  collab_meta: '{{handle}} · {{shop}} · 开始 {{date}}',
  collab_detail: '合作详情'
};

export default creator;
